import { createFileRoute, notFound } from '@tanstack/react-router'

import { env } from '@/env'
import { DevModeSettingsPage } from '@/pages/settings/dev-mode/DevModeSettingsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/dev-mode/')({
  beforeLoad: () => {
    if (env.VITE_DEPLOY_ENV === 'prod') {
      throw notFound()
    }
  },
  component: DevModeSettingsPage,
})
